export interface NormalizedError {
  message: string;
  traceId?: string;
}

export function normalizeNetworkError(error: any): NormalizedError {
  if (!error) return { message: 'Unknown error occurred' };

  const statusCode = error?.response?.status;
  const errorData = error?.response?.data;
  const errorCode = errorData?.error || errorData?.code || '';
  const errorMessage = errorData?.message || errorData?.detail || error.message || '';
  const traceId = error?.response?.headers?.['x-trace-id'];

  let message = '';

  if (!error.response) {
    message = 'Network error: Unable to reach the server';
  } else if (statusCode === 404) {
    message = 'Resource not found or out of scope';
  } else if (statusCode === 403) {
    message = 'Access denied';
  } else if (statusCode === 409 && errorCode === 'wa_scope_violation') {
    message = 'Work area out of scope';
  } else if (statusCode === 422) {
    message = errorMessage || 'Validation error';
  } else if (statusCode === 423) {
    message = 'Resource is locked';
  } else if (errorCode === 'tenant_header_missing') {
    message = 'Tenant configuration missing';
  } else if (errorCode === 'tenant_user_missing') {
    message = 'User not assigned to tenant';
  } else if (errorMessage) {
    message = errorMessage;
  } else {
    message = `Error ${statusCode || 'occurred'}`;
  }

  return { message, traceId };
}
